import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MeuUsuarioService from "../../services/resource/meuUsuarioService";

const service = new MeuUsuarioService();

export function useMeuUsuario() {
    const [perfil, setPerfil] = useState(null);
    const [loading, setLoading] = useState(true);

    const carregar = useCallback(() => {
        setLoading(true);
        service.buscarPerfil()
            .then(res => setPerfil(res.data))
            .catch(error => {
                console.error("Erro ao carregar perfil do usuário", error);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
    }, [carregar]);

    return { perfil, loading, recarregar: carregar };
}
